import React from 'react';

import './ElectionView.css';
import StatesView from './StatesView';
import CandidateView from './CandidateView';
import TotalsView from './TotalsView';
import MapView from './MapView';
import Button from './Button.js';

class ElectionView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			calendarView: false,
			moreInfo: false
		}
	}

	render() {
		if(this.props.data.hasOwnProperty("states")) {
			return(
				<div className = "ElectionView" key = {this.props.year} >
					<div className='showButtons'>
						<Button
							index =   			"polls"
							key = 				"polls"
							name = 				"Prognosen"
							button_handler =	{this.props.poll_toggle_handler}
							active_index = 		{this.props.active_index}
											>
						</Button>					
						<Button
							index =   			"results"
							key = 				"results"
							name = 				"Resultate"
							button_handler =	{this.props.poll_toggle_handler}
							active_index = 		{this.props.active_index}

											>
						</Button>
					</div>
					<TotalsView
						totals = {this.props.data.totals}
						candidates = {this.props.data.candidates}
						parties = {this.props.data.parties}
						notes = {this.props.data.notes}
						mode = {this.props.mode}
						debug = {this.props.debug}
						show = {this.props.show}
						polls = {this.props.data.polls}
						year = {this.props.year}
					></TotalsView>
					{
					this.props.mode==="full" &&
					<a className='ticker-button Button' href='https://www.blick.ch/16175012' target='_parent'>Live-Ticker</a>
					}					
					{
						this.props.mode==="light" &&
						<a className='more-button Button' href='https://www.blick.ch/16185826' target='_parent'>Alle Resultate</a>
						}
					{
					this.props.mode==="full" &&
					<MapView
						data = {this.props.data}
						show = {this.props.show}
					>
					</MapView>
					}
						
					
					{
					this.props.mode==="full" && this.props.data.candidates.a.length>0 && this.props.show==="results" &&
					<div className='candidatesBox'>
						{						
							this.props.data.candidates.a.map((v,i) => {
								return(
									<CandidateView  key = {i} 
										candidate = {v}
										parties = {this.props.data.parties}
									></CandidateView>
								)
							})						
						}	
					</div>
					}
					{
					this.props.mode==="full" && this.props.data.candidates.a.length>0 &&
					<StatesView
						states = {this.props.data.states}
						parties = {this.props.data.parties}
						show = {this.props.show}
						polls = {this.props.data.polls}
					></StatesView>    
					}    
				</div>            
			)
		}	
		else {
			return(false)
		}
	}
}

export default ElectionView
